import { ListItem, ListItemMeta } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { getIconColorFromLevel, getIconFromLevel } from 'sections/client-management/utils/ClientHelpers';
import { IRecentClient } from '../types/recentClients';
import { ClientListItemOptions } from './ClientListItemOptions';
import { useFeatureFlags } from 'core/app/AppContext';
import useClient from 'core/ui/utils/useClient';
import { usePreferencesDispatch, toggleSearchOverlay } from 'core/preferences/usePreferencesContext';

interface Props {
  recentClient: IRecentClient;
}

export const RecentClientListItem: FC<Props> = ({ recentClient }) => {
  const { push } = useHistory();
  const { flagEnabled } = useFeatureFlags();
  const dispatch = usePreferencesDispatch();

  const { id, level } = recentClient;
  const isBrandDashboardActive = flagEnabled('mps-dashboard-brands');
  const client = useClient(id, level);
  const settingsPath = 'settings';

  const listItemClickHandler = () => {
    toggleSearchOverlay(dispatch, false);

    return push(
      `/${level}/${recentClient.id}/${
        level === 'groups' || (level === 'brands' && !isBrandDashboardActive) ? settingsPath : 'dashboard'
      }`,
    );
  };

  return (
    <ListItem
      onClick={listItemClickHandler}
      options={<ClientListItemOptions level={recentClient.level} id={recentClient.id} />}
      tag={
        recentClient.level === 'sites' && flagEnabled('ld-hubspot-toggle')
          ? {
              label: client?.active ? 'Active' : 'Inactive',
              variant: client?.active ? 'active' : 'inactive',
            }
          : undefined
      }
    >
      <ListItemMeta
        avatarIcon={getIconFromLevel(recentClient.level)}
        avatarBg={getIconColorFromLevel(recentClient.level)}
        heading={client?.name !== '' ? client?.name : '...'}
      />
    </ListItem>
  );
};

export default RecentClientListItem;
